import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

export const APPLY_URL = 'https://app.scorpionfunding.com';

export default function Apply() {
  return (
    <section
      id="apply"
      className="relative bg-[#050505] py-28 lg:py-40 overflow-hidden"
      data-testid="apply-section"
    >
      <div
        className="absolute -top-60 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full blur-3xl opacity-10 pointer-events-none"
        style={{ background: 'radial-gradient(circle, #c2a978 0%, transparent 70%)' }}
      />
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20">
          {/* Left: pitch */}
          <div className="lg:col-span-5">
            <div className="flex items-start gap-4 mb-10">
              <span className="w-10 h-px bg-[#c2a978] mt-3" />
              <span className="text-[10px] tracking-[0.5em] uppercase text-[#c2a978]">
                Ch. 05 — Intake
              </span>
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="font-serif text-3xl lg:text-5xl leading-[0.95] tracking-[-0.02em] text-[#f5f5f0]"
            >
              Request<br />
              <span className="italic text-[#c2a978]">capital</span>.
            </motion.h2>
            <p className="mt-8 text-[#8a8a8a] text-sm lg:text-base leading-relaxed max-w-md">
              A senior principal will review your file personally. No credit pull, no fee, no obligation. Decisions within 3 hours.
            </p>

            <div className="mt-14 space-y-5">
              {[
                ['Direct line', '347-864-6712'],
                ['Intake desk', 'Info@scorpionfunding.com'],
                ['Office', 'Miami · New York · London'],
              ].map(([k, v]) => (
                <div
                  key={k}
                  className="flex items-baseline justify-between border-b border-[#c2a978]/10 pb-3"
                >
                  <span className="text-[10px] tracking-[0.35em] uppercase text-[#8a8a8a]">
                    {k}
                  </span>
                  <span className="text-sm text-[#f5f5f0]">{v}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: CTA panel */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-7"
          >
            <div
              className="border border-[#c2a978]/20 bg-[#0a0a0a] p-10 lg:p-14 min-h-[500px] flex flex-col justify-center"
              data-testid="apply-cta-panel"
            >
              <div className="text-[10px] tracking-[0.5em] uppercase text-[#c2a978] mb-6">
                Begin Application
              </div>
              <h3 className="font-serif text-3xl lg:text-5xl text-[#f5f5f0] leading-[1] mb-6">
                Start your <span className="italic text-[#c2a978]">intake</span> in under 3 minutes.
              </h3>
              <p className="text-[#8a8a8a] text-sm lg:text-base leading-relaxed max-w-lg mb-10">
                Secure application. No credit pull. Your file is reviewed by a senior principal — most decisions returned within 3 hours.
              </p>

              <div className="flex flex-wrap items-center gap-4">
                <a
                  href={APPLY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 px-8 py-4 bg-[#c2a978] text-black hover:bg-[#d9c5a0] transition-colors duration-300 text-xs tracking-[0.28em] uppercase font-medium"
                  data-testid="apply-cta-primary"
                >
                  Apply Now <ArrowUpRight size={16} />
                </a>
                <a
                  href="mailto:Info@scorpionfunding.com?subject=Scorpion%20Funding%20Inquiry"
                  className="btn-ghost"
                  data-testid="apply-cta-email"
                >
                  Email Intake
                </a>
              </div>

              <div className="mt-10 pt-8 border-t border-[#c2a978]/10 grid grid-cols-3 gap-6">
                {[
                  ['3 min', 'To complete'],
                  ['No fee', 'To apply'],
                  ['≤ 3 hrs', 'Decision'],
                ].map(([k, v]) => (
                  <div key={k}>
                    <div className="font-serif italic text-[#c2a978] text-2xl lg:text-3xl leading-none">
                      {k}
                    </div>
                    <div className="mt-2 text-[9px] tracking-[0.35em] uppercase text-[#8a8a8a]">
                      {v}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
